import type { FunctionComponent } from 'react';
import * as styles from './styles.module.scss';

type HeaderProps = {
  title: string;
  headerClickable: boolean;
  toggleOpen: () => void;
};

const Header: FunctionComponent<HeaderProps> = ({ title, headerClickable = false, toggleOpen }) => (
  <div
    className={styles.collapsibleBar}
    onClick={headerClickable ? toggleOpen : undefined}
    onKeyDown={headerClickable ? toggleOpen : undefined}
    role="menubar"
    tabIndex={0}
    data-testid="collapsible-bar-header-container"
  >
    <div className={styles.title}>
      <p data-testid="collapsible-bar-header-title">{title}</p>
    </div>
    <div className={styles.header}>
      <button
        className={styles.button}
        onClick={toggleOpen}
        disabled={headerClickable}
        type="button"
      >
        <i className="fal fa-angle-down" />
      </button>
    </div>
  </div>
);

export default Header;
